import { render, staticRenderFns } from "./ProgramServiceSummary.vue?vue&type=template&id=67388eec&scoped=true"
import script from "./ProgramServiceSummary.vue?vue&type=script&lang=js"
export * from "./ProgramServiceSummary.vue?vue&type=script&lang=js"
import style0 from "./ProgramServiceSummary.vue?vue&type=style&index=0&id=67388eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67388eec",
  null
  
)

export default component.exports